import {
	Dialog,
	DialogTitle,
	DialogContent,
	List,
	ListItemButton,
	ListItemText,
	DialogActions,
	Button,
} from "@mui/material";
import type { LassoFeatureType } from "../../../application/map/tools/types";

export const FEATURE_TYPE_LABELS: Record<LassoFeatureType, string> = {
	boundary: "Boundaries",
	sample: "Samples",
	core: "Cores",
	zone: "Zones",
};

interface LassoTypeDialogProps {
	open: boolean;
	availableTypes: LassoFeatureType[];
	onSelect: (type: LassoFeatureType) => void;
	onCancel: () => void;
}

export function LassoTypeDialog({ open, availableTypes, onSelect, onCancel }: LassoTypeDialogProps) {
	return (
		<Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
			<DialogTitle>Select feature type</DialogTitle>
			<DialogContent>
				<List disablePadding>
					{availableTypes.map((type) => (
						<ListItemButton key={type} onClick={() => onSelect(type)}>
							<ListItemText primary={FEATURE_TYPE_LABELS[type]} />
						</ListItemButton>
					))}
				</List>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel}>Cancel</Button>
			</DialogActions>
		</Dialog>
	);
}
